import React, { useMemo } from "react";
import { Icons } from "../constants/icon-library";

function DataTable({ title, data, columns, rowRenderer }) {
  const shouldPaginate = data.length > 20;

  const filteredData = useMemo(() => data, [data]);

  return (
    <div className="card border p-0 mt-4 w-100">
      <div className="card-header p-4 border-bottom bg-body">
        <div className="d-flex justify-content-between align-items-center">
          {typeof title === "string" ? (
            <h3 className="mb-0">{title}</h3>
          ) : (
            title
          )}
        </div>
      </div>

      <div className="card-body p-3">
        <div id={`table-${typeof title === "string" ? title : "custom"}`}>
          <div
            className="table-responsive"
            style={{
              width: "100%",
              overflowX: "auto",
            }}
          >
            <table className="table table-sm table-striped fs-9 mb-0 w-100">
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col.key}
                      className={`sort border-top ${
                        col.alignEnd
                          ? "text-end align-middle pe-0"
                          : "ps-3 align-middle"
                      }`}
                    >
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className="list">
                {filteredData.map((item) => rowRenderer(item))}
              </tbody>
            </table>
          </div>

          {shouldPaginate && (
            <div className="d-flex justify-content-center mt-3">
              <button className="page-link" data-list-pagination="prev">
                <i
                  className={`wb ${Icons("left")} fs-10 me-1 mt-2 align-middle`}
                />
              </button>

              <ul className="mb-0 pagination"></ul>

              <button className="page-link pe-0" data-list-pagination="next">
                <i
                  className={`wb ${Icons("right")} fs-10 me-1 mt-2 align-middle`}
                />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DataTable;

